import React, {useCallback, useContext, useMemo} from 'react'
import RightPanel from './index'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import {User} from '../List/Item/CommentsItem'
import {ThemeContext} from '../ThemeSwitcher'
import {Theme} from '../ThemeSwitcher/switchTheme'
import {showToast} from '../Toast'
import {signout} from "../../api/requests";

type Props = {
  readonly open: boolean
  readonly onClose: () => void
  readonly user: User
}

const UserMenu: React.VFC<Props> = ({ open, onClose, user }) => {
  const { update, theme } = useContext(ThemeContext)
  const userCommentDashboardURL : string = useMemo(() => {
    const url = new URL(window.location.href)
    const host = url.host.replace('admin-','')
    return `${url.protocol}//${host}`
  }, [])

  const opposingTheme = theme === Theme.Light ? Theme.Dark : Theme.Light
  const isDark = theme === Theme.Dark

  const switchTheme = useCallback(() => {
    update(opposingTheme)
    showToast(`Dark Mode ${!isDark ? 'On' : 'Off'}`)
  }, [opposingTheme, update])

  const onSignOut = useCallback(() => {
    signout().then((data) => window.location.href = data.link)
  }, [])

  return (
    <RightPanel open={open} onClose={onClose} title={'Your Profile'}>
      <div className={classNames([styles.TextGroup,styles.RightPanel])}>
        <div className={classNames([styles.Table, styles.MenuProfile])}>
          <div className={classNames([styles.Col, styles.ProfilePic])}>
            <a>
              <div
                className={styles.Avatar}
                style={{ backgroundImage: `url(${user.avatar})` }}
              />
            </a>
          </div>
          <div className={classNames([styles.Col, styles.ProfileName])}>
            <div className={styles.GroupSubhead}>{user.name}</div>
            Name: <b>{user.displayName}</b>
            <br />
          </div>
        </div>
      </div>

      <div className={styles.LinkGroup}>
        <a className={styles.Link} title='User Comment Dashboard' href={userCommentDashboardURL} target='_blank'>
          <span className={styles.LinkNoIcon}>User Comment Dashboard</span>
          <div className={styles.IconExternalLink}/>
        </a>
        <a className={styles.Link} onClick={onSignOut}>
          <span className={classNames([styles.LinkIcon, styles.IconSignOut])} />
          <span className={styles.LinkLabel}>Sign Out</span>
        </a>
        <a className={styles.Link} onClick={switchTheme}>
          <span
            className={classNames([styles.LinkIcon, styles.IconDarkMode])}
          />
          <span className={styles.LinkLabel}>
            {isDark ? 'Disable' : 'Enable'} Dark Mode
          </span>
        </a>
      </div>
    </RightPanel>
  )
}

export default UserMenu
